import { Box } from '@mui/material'
import React from 'react'
import ChatHeader from './ChatHeader'
import Messaage from './Messaage'


function ChatBox() {
    return (
        <div>
            <Box>
               <ChatHeader/>
            </Box>
            <Box>
               <Messaage/> 
            </Box>
        </div>
    )
}

export default ChatBox
